/**
 * 弹框列表查看组件(上面一个关闭按钮，下面一个确定按钮，中间自定义)
 */

 <template>
  <div class="alertMenu" v-if="status">
      <div class="alertMenu__container" :style="`width:${width? typeof width === 'number' ? width+'px' : width : 'inherit'}; height:${height? typeof height === 'number' ? height+'px' : height : 'inherit'}; `">
          <div class="alertMenu__close right" @click="hide()">
              <span class="alertMenu__close__text">x</span>
          </div>
          <div class="alertMenu__content">
              <slot></slot>
          </div>
          <div class="alertMenu__btn" @click="submit()">确定</div>
      </div>
  </div>
</template>
<script>

export default {
  name: "AlertMenu",
  props:{
      width:{
        type: Number | String,
    },
    height:{
        type: Number | String,
    },
  },
  data() {
    return {
        status:false
    };
  },
  created() {},
  mounted() {},
  methods: {
      show(){
          this.status = true;
      },
      hide(){
          this.status = false;
      },
      submit(){
        this.hide();
        if(this.$parent.submitCallBack){
            this.$parent.submitCallBack()
        }
        this.$emit("submit")
      }
  }
};
</script>
<style scoped lang="less">
.alertMenu{
    position: fixed;
    left: 0;
    top: 0;
    width:100%;
    height:100%;
    background-color:rgba(0, 0, 0, 0.6);

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
}
.alertMenu__container{
    background-color: #ffffff;
    padding: 15px;
    border-radius: 5px;
    position: relative;
    overflow: auto;
    padding-top: 70px;
    
}
.alertMenu__close{
    text-align: right;
    &.right{
      position: absolute;
      right: 10px;
      top:10px;
    }
    
}
.alertMenu__close__text{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #5F0AFF;
    color: white;
    display: inline-block;
    text-align: center;
    line-height: 40px;
    font-size: 25px;
    cursor: pointer;
}
.alertMenu__content{

}
.alertMenu__btn{
    width: 90px;
    height: 40px;
    border-radius: 20px;
    background-color: #5F0AFF;
    color:#ffffff;
    font-size: 18px;
    text-align: center;
    line-height: 40px;
    margin: auto;
    cursor: pointer;
}
</style>
